import { NgClass, NgIf, NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  signal,
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'mzic-spotify-avatar',
  imports: [NgIf, NgStyle, NgClass, MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './spotify-avatar.component.html',
  styleUrls: ['./spotify-avatar.component.scss'],
})
export class SpotifyAvatarComponent {
  @Input({ required: true }) imageUri!: string;
  @Input({ required: true }) altImage!: string;
  @Input({ required: true }) stampUri!: string;
  @Input() largeImage = false;

  protected isLoading = signal(true);

  onLoading() {
    this.isLoading.set(false);
  }
}
